import { useState, useEffect } from 'react';
import axios from 'axios';
import { Star, Quote } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await axios.get(`${API}/testimonials`);
      setTestimonials(response.data);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
    }
  };

  return (
    <section id="testimonials" className="py-20 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16" data-testid="testimonials-header">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            What Our <span className="gold-gradient">Clients Say</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Don't just take our word for it - hear from our satisfied customers
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-[#1a1a1a] rounded-xl p-6 hover:transform hover:scale-105 transition-all duration-300 border border-gray-800 hover:border-[#d4af37]"
              data-testid={`testimonial-${testimonial.id}`}
            >
              <Quote className="w-8 h-8 text-[#d4af37] mb-4" />
              
              <div className="flex mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-[#d4af37] fill-current" />
                ))}
              </div>
              
              <p className="text-gray-300 mb-4 italic">"{testimonial.comment}"</p>
              
              <div className="border-t border-gray-800 pt-4">
                <p className="font-bold text-white">{testimonial.name}</p>
                <p className="text-sm text-[#d4af37]">{testimonial.service}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-400">
            Join our growing list of satisfied customers across Calgary!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;